<script>
import AdminFiltroPanel from "./Panel";
import AdminFiltroPlaceholder from "./Placeholder";

export default {
  name: "AdminFilters",
  components: { AdminFiltroPlaceholder, AdminFiltroPanel },
  props: {
    habilitado: { type: Number, required: true },
    prioritario: { type: Number, required: true },
    isLoading: { type: Boolean, default: false },
  },
  computed: {
    mostrarDeshabilitados: {
      set(activo) {
        this.$emit("filtrar", { habilitado: activo ? -1 : 1 });
      },
      get() {
        return this.habilitado !== 1;
      },
    },
    mostrarSoloDeshabilitados: {
      set(activo) {
        this.$emit("filtrar", { habilitado: activo ? 0 : -1 });
      },
      get() {
        return this.habilitado === 0;
      },
    },
    mostrarSoloPrioritarios: {
      set(activo) {
        this.$emit("filtrar", { prioritario: activo ? 1 : -1 });
      },
      get() {
        return this.prioritario === 1;
      },
    },
  },
  watch: {
    habilitado(habilitado) {
      this.$emit("filtrar", { habilitado });
    },
    prioritario(prioritario) {
      this.$emit("filtrar", { prioritario });
    },
  },
};
</script>

<template>
  <div>
    <admin-filtro-panel
      v-if="!isLoading"
      heading="Admin"
      icono="sliders"
      :total="false"
    >
      <div class="list-group">
        <label class="list-group-item">
          <input type="checkbox" v-model="mostrarDeshabilitados" />
          <span> Mostrar <b>deshabilitados</b> </span>
          <i class="fa fa-eye-slash"></i>
        </label>

        <label
          class="list-group-item"
          :class="{ disabled: !mostrarDeshabilitados }"
        >
          <input
            type="checkbox"
            v-model="mostrarSoloDeshabilitados"
            :disabled="!mostrarDeshabilitados"
          />
          <span> Mostrar <b>solo deshabilitados</b> </span>
          <i class="fa fa-minus"></i>
        </label>

        <label class="list-group-item">
          <input type="checkbox" v-model="mostrarSoloPrioritarios" />
          <span> Mostrar <b>solo prioritarios</b> </span>

          <i class="fa fa-star"></i>
        </label>
      </div>
    </admin-filtro-panel>
    <admin-filtro-placeholder v-else></admin-filtro-placeholder>
  </div>
</template>

<style scoped>
.list-group {
  margin: 0;
  border-radius: 0;
  border: 0;
  min-height: 160px;
}
.list-group > .list-group-item {
  display: block;
  font-weight: normal;
  border-radius: 0;
  border-left: 0;
  border-right: 0;
  cursor: pointer;
  position: relative;
  padding: 10px 35px;
}

.list-group > .list-group-item:first-child {
  border-top: 0;
}
.list-group > .list-group-item:last-child {
  border-bottom: 0;
}
.list-group > .list-group-item:hover {
  background: #f4f5f7;
  color: #434a54;
}

.list-group > .list-group-item.disabled,
.list-group > .list-group-item.disabled:hover {
  color: #777;
  cursor: not-allowed;
  background-color: #eee;
}

.list-group > .list-group-item > input[type="checkbox"] {
  position: absolute;
  left: 15px;
  top: 15px;
  margin: 0;
  padding: 0;
}
.list-group > .list-group-item > .fa {
  position: absolute;
  top: 50%;
  right: 10px;
  font-size: 23px;
  margin-top: -18px;
  color: #999;
}
</style>